import { defineStore } from 'pinia';
import { useNuxtApp } from "#app";
import { FrequentTechCategoryCollectionType } from "~/types/frequentTech/FrequentTechCategoryCollectionType";

export const useFrequentTechCategoryStore = defineStore({
    id: 'frequentTechCategory',
    state: (): FrequentTechCategoryCollectionType => ({
        list: undefined,
        error: undefined,
    }),
    getters: {
        formattedItems(state: FrequentTechCategoryCollectionType): string {
            if (state.list === undefined) {
                return '';
            }

            return state.list.map(item => ` * ${item.label}`).join('\n');
        },

        filterItems(state: FrequentTechCategoryCollectionType): string[] {
            const items = ['all'];
            if (state.list === undefined) {
                return [];
            }

            return items.concat(state.list.map(item => item.label));
        }
    },
    actions: {
        async fetchList() {
            try {
                const fields = ['title'];
                const sort = 'sorting:desc';
                const response = await useNuxtApp().axios.get('/frequent-tech-categories', {
                    params: {
                        fields,
                        sort,
                    }
                });
                if (response?.data?.data === undefined || !response?.data?.data.length) {
                    return;
                }

                this.list = response?.data?.data.map(item => ({
                    id: item?.id,
                    label: item?.attributes?.title,
                }));
            } catch (error) {
                console.log(error);
                this.error = error.message;
            }

            return true;
        },
    },
});
